import joinClassNames from '../primitives/joinClassNames.js'

/**
 * Compact inline status notice (planner API messages, form feedback).
 * @param {{ variant?: 'success' | 'error' | 'info' | 'warning', children: React.ReactNode, onDismiss?: () => void, className?: string }} props
 */
export default function StatusPill({ variant = 'info', children, onDismiss, className = '', ...props }) {
  const role = variant === 'error' ? 'alert' : 'status'
  return (
    <span
      className={joinClassNames('status-pill', `status-pill--${variant}`, className)}
      role={role}
      {...props}
    >
      {children}
      {onDismiss && (
        <button
          type="button"
          className="status-pill__dismiss"
          onClick={onDismiss}
          aria-label="Dismiss"
        >
          ×
        </button>
      )}
    </span>
  )
}
